import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { Typography, Divider, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import {
  checkErrorMessage,
  checkResponseData,
  customToastify,
} from "../../components/pages/utils/utilsFunctions";
import ReactPlayer from "react-player";
import { newSubscriptionInfoApi } from "../../services/supportApi";
import { toast } from "react-toastify";
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowBackIosIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export default function IphoneApp() {
  const [expanded, setExpanded] = React.useState("");
  const [mobileNumber, setMobileNumber] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [invliadEmail, setInvliadEmail] = React.useState(false);

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const newSubscriptionSubmit = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...");
    try {
      const response = await newSubscriptionInfoApi({
        subscriptionSubject: "iosPublish",
        email,
        mobileNumber,
      });
      const resData = checkResponseData(response);
      if (resData["success"]) {
        toast.update(toastMsg, {
          render: resData["message"] || "درخواست انجام شد",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        setMobileNumber("");
        setEmail("");
      } else {
        toast.update(toastMsg, {
          render: resData["message"] || "اتفاق غیر منتظره پیش آمده است",
          type: "info",
          isLoading: false,
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error-reportBugToBack", error);
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.update(toastMsg, {
        render: errMsg || "مشکلی وجود دارد",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const sendInfo = () => {
    if (email.length > 0) {
      if (validateEmail(email)) {
        newSubscriptionSubmit();
      } else {
        setInvliadEmail(true);
        customToastify("error", "لطفا ایمیل را به درستی وارد کنید", 3000);
      }
    } else if (email.length == 0 && mobileNumber.length == 0) {
      console.log("Run");
      customToastify(
        "error",
        "لطفا یکی از مقادیر شماره تلفن همراه یا ایمیل را وارد کنید",
        3000
      );
    } else {
      newSubscriptionSubmit();
    }
  };
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        sx={{ p: 0, width: "200px", mx: "auto" }}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography sx={{ fontSize: "14px" }}>
            اطلاع از انتشار نسخه IOS
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TextField
            sx={{ my: 0.5 }}
            id="outlined-basic"
            label="شماره همراه"
            variant="outlined"
            value={mobileNumber}
            size="small"
            onChange={(e) => {
              setMobileNumber(e.target.value);
            }}
          />
          <TextField
            sx={{ my: 0.5 }}
            id="outlined-basic"
            label="ایمیل"
            value={email}
            helperText={invliadEmail ? "ایمیل نامعتبر است" : null}
            error={invliadEmail}
            variant="outlined"
            size="small"
            onChange={(e) => {
              if (invliadEmail) setInvliadEmail(false);
              setEmail(e.target.value);
            }}
          />
          <Button variant="contained" onClick={sendInfo}>
            ثبت
          </Button>
          <Typography sx={{ fontSize: "12px", mx: 0.5 }}>
            حداقل یکی از دو روش شماره همراه یا ایمیل تکمیل شود
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
        sx={{ p: 0, width: "200px", mx: "auto" }}
      >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography sx={{ fontSize: "14px" }}>آشنایی با اوملنگ</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ReactPlayer
            controls={true}
            className="react-player"
            url="https://umlang.com/video/newVideo/201.mp4"
            light={
              <img
                src="https://umlang.com/video/img/201.png"
                alt="Thumbnail"
                style={{
                  border: "double 6px",
                  width: "100%",
                  height: "100%",
                  borderRadius: "45px",
                  opacity: "0.5",
                }}
              />
            }
            width="100%"
            height="100%"
            onEnded={handleChange("panel1")}
            playing={true}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
}
